import { AlertProps } from "@alm/flow-ds/components";
import React from "react";
import { businessLogicValue } from "schemas/elements";

export interface BusinessLogicContextProps {
	handleUpdateStore: (value: businessLogicValue) => void;
	validation: boolean;
	elementIndex?: number;
	id: string;
	value: businessLogicValue;
	action: "afterPatch" | "onLoad" | "beforeSave";
	addAlert: (alert: string, status: AlertProps["status"]) => void;
}

export default React.createContext<Partial<BusinessLogicContextProps>>({});
